module.exports = __webpack_public_path__ + "img/AlessandraCesano.436dae47.png";